export default "__VITE_ASSET__90eeb6ea__"